// app/javascript/compcalc/components/utils/ItemArrayList.jsx

import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
});


// props.items = array of array of something (use text at props.textIndex), props.selectedIndex, props.onIndexChanged()
class ItemArrayList extends React.PureComponent {

  constructor(props) {
    super(props);

    // this.clicks = props.items.map((item, index) => { return () => props.onIndexChanged(index); });
    //
    // this.items = props.items.map((item, index) => (
    //   <ListItem dense button
    //             key={ `${index}` }
    //             selected={ props.selectedIndex === index }
    //             onClick={ this.clicks[index] }>
    //     <ListItemText primary={ props.titleIndex >= 0 ? `${item[props.titleIndex]}` : '' }
    //                   secondary={ props.textIndex >= 0 ? `${item[props.textIndex]}` : ''  } />
    //   </ListItem>
    // ));
  }

  render() {
    // console.log("ItemArrayList.render()");

    // let { classes } = this.props;
    // return (
    //   <div>
    //     {
    //       this.items
    //     }
    //   </div>
    // )

    return (
      <div>
        {
          this.props.items.map((item, index) => (
            <ListItem dense button
                      key={ `${index}` }
                      selected={ this.props.selectedIndex === index }
                      onClick={() => this.props.onIndexChanged(index)}>
              <ListItemText primary={ this.props.titleIndex >= 0 ? `${item[this.props.titleIndex]}` : '' }
                            secondary={ this.props.textIndex >= 0 ? `${item[this.props.textIndex]}` : ''  } />
            </ListItem>
          ))
        }
      </div>
    );
  }

};

export default withStyles(styles)(ItemArrayList);
